const borderRadius = {
  base: "0.75rem",
};
export default borderRadius;
